// https://jira.lais.net/browse/WEB-39857
export const res = {
  close: {
    is: 'Loka',
    en: 'Close',
    pl: 'Zamknij',
  },
  // TODO: verify translations below to eng/pl
  title: {
    is: 'Villa í samskiptum',
    en: 'Communication error',
    pl: 'Błąd komunikacji',
  },
  description: {
    is: 'Því miður tókst ekki að klára þessa aðgerð',
    en: 'Unfortunately, this action could not be completed',
    pl: 'Niestety nie można było ukończyć tej operacji',
  },
  title_InvalidUser: {
    is: 'Aðgangur að reikningi',
    en: 'Account access',
    pl: 'Dostęp do konta',
  },
  description_InvalidUser: {
    is: 'Þú hefur ekki aðgang að reikning',
    en: 'You do not have access to this account',
    pl: 'Nie masz dostępu do tego konta',
  },
};
